import { EnvVariable } from '../enums';

export const getStringEnvVariable = (variable: EnvVariable, fallback = '') => process.env[variable] ?? fallback;
export const getBooleanEnvVariable = (variable: EnvVariable, fallback = false) =>
  process.env[variable]?.toLowerCase() === 'true' ?? fallback;
